import { IBaseModel } from "../../interfaces/ibase.model";

/* eslint-disable @typescript-eslint/naming-convention */
// Note camelCase: DB attribute
export abstract class BaseModel implements IBaseModel {
    Id?: string | number;

    static create: <T, S>(obj: T) => S
}